import React from 'react';
import ReactDOM from 'react-dom';

interface ScrimProps {
  /** Content to center inside the scrim (e.g. a modal panel) */
  children?: React.ReactNode;
  /** Called when the user clicks directly on the scrim (not on children) */
  onClick?: () => void;
  /** CSS z-index. Defaults to 50. */
  zIndex?: number;
}

/**
 * A full-screen overlay that blurs the content behind it without adding any colour.
 * Rendered via a React portal directly on document.body so it always covers the
 * full viewport regardless of any containing block or stacking context.
 * When children are provided they are centred on screen; clicks on the scrim
 * itself call `onClick` while clicks on children are swallowed.
 */
export function Scrim({ children, onClick, zIndex = 50 }: ScrimProps) {
  const content = children ? (
    <div
      className="fixed inset-0 w-screen h-screen backdrop-blur-sm flex items-center justify-center p-4"
      style={{ zIndex }}
      onClick={onClick}
    >
      <div className="w-full flex justify-center" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  ) : (
    <div
      className="fixed inset-0 w-screen h-screen backdrop-blur-sm"
      style={{ zIndex }}
      onClick={onClick}
    />
  );

  return ReactDOM.createPortal(content, document.body);
}
